module.exports = __webpack_public_path__ + "img/index-preview-mobile.80397fc4.svg";